<template>
  <canvas ref="chart"></canvas>
</template>

<script>
import { Chart } from "chart.js";

export default {
  name: "ConversionChart",
  props: {
    chartData: {
      type: Object,
      default: () => ({ labels: [], registrations: [], subscribers: [], conversionRate: [] }),
    },
    registrationsLabel: {
      type: String,
      default: "Cadastros",
    },
    subscribersLabel: {
      type: String,
      default: "Assinantes",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    renderChart() {
      if (!this.chartData || !this.chartData.labels) return;

      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.chart.getContext("2d");

      // Get subscribers data (supports both 'subscribers' and 'newSubscribers')
      const subscribersData = this.chartData.subscribers || this.chartData.newSubscribers || [];

      const datalabelsPlugin = {
        id: 'conversionDatalabels',
        afterDatasetsDraw(chart) {
          const { ctx } = chart;
          chart.data.datasets.forEach((dataset, datasetIndex) => {
            if (dataset.type === 'line') {
              const meta = chart.getDatasetMeta(datasetIndex);
              meta.data.forEach((point, index) => {
                const value = dataset.data[index];
                if (value === 0 || value === null || value === undefined) return;

                ctx.save();
                ctx.fillStyle = dataset.borderColor || '#e76f51';
                ctx.font = 'bold 10px sans-serif';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';
                ctx.fillText(value.toFixed(1) + '%', point.x, point.y - 8);
                ctx.restore();
              });
            }
          });
        },
      };

      this.chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.chartData.labels,
          datasets: [
            {
              label: this.registrationsLabel,
              data: this.chartData.registrations,
              backgroundColor: "#2e4664",
              yAxisID: "y",
              order: 2,
            },
            {
              label: this.subscribersLabel,
              data: subscribersData,
              backgroundColor: "#4a7c59",
              yAxisID: "y",
              order: 3,
            },
            {
              label: "Taxa de conversão (%)",
              data: this.chartData.conversionRate,
              type: "line",
              borderColor: "#e76f51",
              backgroundColor: "rgba(231, 111, 81, 0.1)",
              borderWidth: 2,
              pointBackgroundColor: "#e76f51",
              pointRadius: 4,
              fill: false,
              yAxisID: "y1",
              order: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            },
          },
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              type: "linear",
              display: true,
              position: "left",
              beginAtZero: true,
              title: {
                display: true,
                text: "Quantidade",
              },
            },
            y1: {
              type: "linear",
              display: true,
              position: "right",
              beginAtZero: true,
              max: 100,
              title: {
                display: true,
                text: "Conversão %",
              },
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        },
        plugins: [datalabelsPlugin],
      });
    },
  },
};
</script>
